import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CallToAction = () => {
  return <section className="py-6 md:py-8 bg-bttf-bg text-bttf-text relative overflow-hidden" id="cta" data-id="element-77">
      <div className="absolute inset-0 bg-gradient-to-br from-bttf-highlight/30 to-bttf-primary/30 mix-blend-overlay" data-id="element-78"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-79">
        <div className="text-center mb-6" data-id="element-80">
          <div className="flex justify-center mb-2" data-id="element-81">
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-82" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-83">
            Take Action Before This Offer Disappears
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto" data-id="element-84"></div>
        </div>
        <div className="max-w-3xl mx-auto text-center" data-id="element-85">
          <p className="text-xl mb-6 text-bttf-text" data-id="element-86">
            👉 Click below to claim your edition before this limited collector's
            run hits 88 MPH.
          </p>
          <a href="#pricing" className="inline-flex items-center bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text font-bold px-8 py-4 rounded-md text-lg transition-all transform hover:scale-105 shadow-md hover:shadow-neon-orange" data-id="element-87">
            Get My Copy Now — Limited 40th Anniversary Edition
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-88" />
          </a>
        </div>
      </div>
    </section>;
};
const StarIcon = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-89">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-90"></polygon>
  </svg>;